import React from "react";

import CheckIcon from "@uui/Check";
import CopyIcon from "@uui/Copy01";
import EditIcon from "@uui/Edit05";

import useEditReport from "@app/analytics/MeetingReport/hooks/useEditReport";
import * as Events from "@app/analytics/tracking/events";

import CopyButton from "@rui/CopyButton";
import { Row } from "@rui/Stack";

import { NoteSectionActionButton } from "../styles";

const CopyAndEditActionsRow = ({
  isEditing,
  canEdit,
  canCopy,
  copyValue,
  name,
}: {
  isEditing: boolean;
  canEdit: boolean;
  canCopy: boolean;
  copyValue: string;
  name: string;
}) => {
  const { enterEditMode } = useEditReport();

  const handleCopyNoteSection = () => () => {
    Events.copyToClipboard({ name: `${name}-copy` });
  };

  if (isEditing) return null;

  const handleEnterEditMode = () => enterEditMode("notes");

  return (
    <Row variant="left">
      {canCopy && (
        <CopyButton
          copyValue={copyValue}
          copyTimeout={2500}
          onClick={handleCopyNoteSection}
          renderButton={(buttonProps, copied) => (
            <NoteSectionActionButton
              className="note-section__action"
              startIcon={copied ? <CheckIcon /> : <CopyIcon />}
              {...buttonProps}
            >
              {copied ? "Copied!" : "Copy"}
            </NoteSectionActionButton>
          )}
        />
      )}
      {canEdit && (
        <NoteSectionActionButton
          className="note-section__action"
          startIcon={<EditIcon />}
          onClick={handleEnterEditMode}
        >
          Edit
        </NoteSectionActionButton>
      )}
    </Row>
  );
};

export default CopyAndEditActionsRow;
